import { Button, Col, Row } from "antd";
import { FC } from "react";
import openModal from "../../../../components/modal/openModal";
import PopoverList from "../../../../components/popups/popoverList";
import LeasingStore from "../../../../contexts/leasingStore";
import _t from "../../../../lang/translate";
import { LeasingPartialCaseType } from "../../../../types/leasingTypes";

const LeasingValidationActions: FC = () => {
  const { leasingCase, setLeasingCase } = LeasingStore.useContainer();
  const { id, flags } = leasingCase;
  const { contractGenerated, validationStarted, unMergedCustomer, validationAccepted } = flags;

  const handleReject = async () => {
    try {
      const payload = await openModal<LeasingPartialCaseType>("leasingRejectCase", { id });
      setLeasingCase({ ...leasingCase, ...payload });
    } catch (error) {
    }
  };

  const handleAccept = async () => {
    try {
      const payload = await openModal<LeasingPartialCaseType>("leasingAcceptCase", { id });
      setLeasingCase({ ...leasingCase, ...payload });
    } catch (error) {
    }
  };

  const disabled = !validationStarted || unMergedCustomer || validationAccepted;

  return (
    <div>
      <Row justify="space-between" align="middle">
        <Col>
          <PopoverList list={[
            contractGenerated ? "Kontrakter er allerede genereret" : null,
            !validationStarted ? "Validering er ikke begyndt." : null,
          ].filter(Boolean) as string[]}>
            <Button disabled={contractGenerated || !validationStarted} danger type="primary" onClick={handleReject}>
              {_t("reject", "case")}
            </Button>
          </PopoverList>

        </Col>
        <Col>
          <PopoverList list={[
            !validationStarted ? "Validering er ikke begyndt." : null,
            validationAccepted ? "Sagen er allerede accepteret." : null,
            unMergedCustomer ? "Der mangles kundedata." : null,
          ].filter(Boolean) as string[]}>
            <Button type="primary" color="green" disabled={disabled} onClick={handleAccept}>
              {_t("accept", "case")}
            </Button>
          </PopoverList>
        </Col>
      </Row>
    </div>
  );
};

export default LeasingValidationActions;
